import { render, staticRenderFns } from "./theme-picker.vue?vue&type=template&id=41be2046"
import script from "./theme-picker.vue?vue&type=script&lang=js"
export * from "./theme-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41be2046')) {
      api.createRecord('41be2046', component.options)
    } else {
      api.reload('41be2046', component.options)
    }
    module.hot.accept("./theme-picker.vue?vue&type=template&id=41be2046", function () {
      api.rerender('41be2046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme-picker.vue"
export default component.exports